module.exports = __webpack_public_path__ + "static/img/03-4.59d57211.png";